import {
    SET_ABOUT_COMPANY,
    SET_ABOUT_COMPANY_BANNER,
    SET_CERTIFICATES,
    SET_CONTACT_US,
    SET_EXPORT,
    SET_MANAGEMENT
} from "./mutation_types";
import {SET_ERROR, SET_LOADING} from "../eventManagement/mutation_types";


export default {
    [SET_EXPORT](state,response){
        state.exports = response.resource.data;
        state.countries = response.countries.data;
    },
    [SET_CERTIFICATES](state,resource){
        state.certificates = resource.data;
    },
    [SET_ABOUT_COMPANY](state,resource){
        state.aboutCompany = resource.data;
    },
    [SET_ABOUT_COMPANY_BANNER](state,resource){
        state.aboutCompanyBanner = resource.data.banners[0];
    },
    [SET_MANAGEMENT](state,resource){
        state.management = resource.data;
    },
    [SET_CONTACT_US](state,resource){
        state.contactUsForm = resource.data;
    },

    [SET_ERROR](state, error) {
        state.error = error;
    },

    [SET_LOADING](state, loading) {
        state.loading = loading;
    },
}